import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import household_at_born_on from './household_at_born_on'
import household_at_cohabitants from './household_at_cohabitants'
import household_at_cohabitation_type from './household_at_cohabitation_type'
import household_at_contact_details from './household_at_contact_details'
import household_at_deductible_amount from './household_at_deductible_amount'
import household_at_flood_area from './household_at_flood_area'
import household_at_furnishing_level from './household_at_furnishing_level'
import household_at_number_of_previous_claims from './household_at_number_of_previous_claims'
import household_at_personal from './household_at_personal'
import household_at_prev_insurance from './household_at_prev_insurance'
import household_at_quote from './household_at_quote'
import household_at_square_meters from './household_at_square_meters'
import household_at_statement_of_fact from './household_at_statement_of_fact'
import household_at_zip from './household_at_zip'

const getSteps = (params: StepConfigParams) =>
  ({
    household_at_born_on: household_at_born_on(params),
    household_at_cohabitants: household_at_cohabitants(params),
    household_at_cohabitation_type: household_at_cohabitation_type(params),
    household_at_contact_details: household_at_contact_details(params.clientHelpers.apiService),
    household_at_deductible_amount: household_at_deductible_amount(params),
    household_at_flood_area: household_at_flood_area(params),
    household_at_furnishing_level: household_at_furnishing_level(params),
    household_at_number_of_previous_claims: household_at_number_of_previous_claims(params),
    household_at_prev_insurance: household_at_prev_insurance(params),
    household_at_quote: household_at_quote(params),
    household_at_square_meters: household_at_square_meters(params),
    household_at_personal: household_at_personal(params),
    household_at_zip: household_at_zip(params),
    household_at_statement_of_fact: household_at_statement_of_fact(params),
  }) as const satisfies AnySteps

export default getSteps
